<template>
  <div>
    <div class="flex justify-end">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-3 bg-primary"
        @click="goBack()"
        >Back</vs-button
      >
    </div>
    <vx-card title="Folders" class="lead-listing">
      <div class="flex justify-between addbtn-col sm: mb-0 md:mb-6">
        <div class="set flex">
          <label class="limit_label">{{ $t("labels.show") }}</label>
          <v-select
            v-model="limit"
            :options="limitarr"
            :reduce="(limitarr) => limitarr.value"
            :clearable="false"
            label="text"
            class="px-1"
          />
        </div>
        <router-link :to="{ name: 'AddSubFolder', params: { folder_id } }">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="float-right btn-add sm: mb-6 md:m-0"
            v-if="checkPermission('folders', 'add')"
            >{{ $t("labels.add_folder") }}</vs-button
          >
        </router-link>
      </div>
      <vs-table :data="subFolders" class="permission">
        <template slot="thead">
          <vs-th class="col-md-5">{{ $t("labels.folder_name") }}</vs-th>
          <vs-th class="col-md-5">{{ $t("labels.status") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.folder_name }}</vs-td>
            <vs-td>{{ tr.status == 1 ? "Active" : "In-Active" }}</vs-td>
            <vs-td width="125">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({
                      name: 'EditSubFolder',
                      params: { folder_id: folder_id, sub_folder_id: tr.id },
                    })
                  "
                ></vs-button>
                <!-- v-if="checkPermission('folders', 'modify')" -->
                <!-- v-if="checkPermission('folders', 'delete')" -->
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subFolders: [],

      index: -1,
      totalPage: 1,
      currentx: 1,
      // limit: this.$store.state.limit,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
    };
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getSubFolders();
    },
    currentx() {
      this.getSubFolders();
    },
  },
  computed: {
    folder_id() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
  },
  methods: {
    async getSubFolders() {
      let input = {
        page: this.currentx,
        perPage: this.limit,
      };

      let response = await this.getHTTPPostResponse(
        `/folders/${this.folder_id}/subfolder/list`,
        input
      );

      if (response) {
        let data = response.data;
        this.subFolders = [];
        let perPage = this.limit;
        let totalPage = Math.ceil(response.data.count / perPage);
        this.totalPage = totalPage;
        data.subFolders.map((parent) => {
          this.subFolders.push(parent);
        });
      }
    },
    deleteConfirm(index) {
      this.index = index;
      let text = this.$t("strings.delete_confirm");
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: text,
        accept: this.deleteSubFolder,
      });
    },
    async deleteSubFolder() {
      if (this.index < 0) return;
      let index = this.index;
      const id = this.subFolders[index].id;
      const url = `folders/${this.folder_id}/subfolder/${id}`;
      let response = await this.getHTTPDeleteResponse(url, null, true);
      if (response) {
        this.getSubFolders();
      }
    },
    goBack() {
      const query = this.$route.query;
      if (query) {
        const { vessel_type_id, vessel_sub_type_id } = query;
        this.$router.push({
          name: "ListSection",
          params: {
            vessel_type_id,
            vessel_sub_type_id,
          },
        });
      } else if (this.subFolders.length) {
        const { vessel_type_id, vessel_sub_type_id } =
          this.subFolders[0].folder;
        this.$router.push({
          name: "ListSection",
          params: {
            vessel_type_id,
            vessel_sub_type_id,
          },
        });
      } else {
        this.$router.push({
          name: "folders",
        });
      }
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getSubFolders();
  },
};
</script>
